import Vue from 'vue'
import Router from 'vue-router'
// import Home from '../views/Home.vue'
// import Dashboard from '../components/Dashboard.vue'
// import Users from '../views/Users.vue'
// import UserDetail from '../views/UserDetail.vue'

import axios from 'axios'
import OriginDownload from "../views/OriginDownload";
import LoadType from "../views/LoadType";
import Trucks from "../views/Trucks";
import CompanyDetail from "../views/CompanyDetail";
import DischargePlace from "../views/DischargePlace";
import Users from "../views/Users";
import InsertPriceBuyDelivery from "../views/PriceBuyDelivery/InsertPriceBuyDelivery";
import InsertDeliveryDocuments from "../views/DeliveryDocuments/InsertDeliveryDocuments";
import ReportPriceBuyDelivery from "../views/PriceBuyDelivery/ReportPriceBuyDelivery";
import InsertPrePayment from "../views/PrePayment/InsertPrePayment";
import ReportPrePayment from "../views/PrePayment/ReportPrePayment";
import ReportDeliveryDocuments from "../views/DeliveryDocuments/ReportDeliveryDocuments";
import ReportDriverDetail from "../views/Reports/ReportDriverDetail";
import ReportDeliveryLoadDetail from "../views/Reports/ReportDeliveryLoadDetail";
import ListDeliveryLoad from "../views/Reports/ListDeliveryLoad";
import LandingPage from "../components/LandingPage";
import ReportAllListDeliveryLoad from "../views/Reports/ReportAllListDeliveryLoad";
import Signatures from "../views/Signatures";
import Login from "../components/Login";
import Container from "../components/Container";
import TonajeLimit from "../views/TonajeLimit";
import PrintPreview from "../views/PrintPreview";
import AccountingYear from "../views/AccountingYear";

// axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
Vue.use(Router)

let router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({y: 0}),
  routes: configRoutes(),

});

export default router

router.beforeEach((to, from, next) => {
  console.log("before each" + " token is " + localStorage.getItem('token') + "to" + to.path);
  // console.log("before each"+next);
  if (to.path == '/') {
     window.location.href = '/home';
  }


  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log("validate requiresAuth");

    if (localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
      console.log("validate is null");

      next({
        path: '/pages/login',
        params: {nextUrl: to.fullPath}
      })
    } else {
      validate_user(next, to);

    }
  } else if (to.matched.some(record => record.meta.guest)) {
    // if(localStorage.getItem('jwt') == null){
    next()

  } else {
    next()
  }
});

function configRoutes() {
  return [
    {
      path: '/',
      name: 'root',

      component: Container,
      redirect: "/home",

      // meta: {requiresA?uth: true},
      children: [
        {
          path: '/home',
          name: 'LandingPage',
          component: LandingPage,
          // redirect: '/home',
          meta: {requiresAuth: true},

        },
        {
          path: '/origin-download',
          name: 'OriginDownload',
          component: OriginDownload,
          meta: {requiresAuth: true
            ,requiresRole:'origin_loads'},
        },
        {
          path: '/load-type',
          name: 'LoadType',
          component: LoadType,
          meta: {requiresAuth: true
            ,requiresRole:'load_types'},
        },
        {
          path: '/signatures',
          name: 'Signatures',
          component: Signatures,
          meta: {requiresAuth: true
            ,requiresRole:'origin_loads'},
        },
        {
          path: '/tonaje_limit',
          name: 'TonajeLimit',
          component: TonajeLimit,
          meta: {requiresAuth: true
            ,requiresRole:'tonaje_limit'},
        },
        {
          path: '/add-truck',
          name: 'Trucks',
          component: Trucks,
          meta: {requiresAuth: true
            ,requiresRole:'trucks'},
        },
        {
          path: '/settings',
          name: 'CompanyDetail',
          component: CompanyDetail,
          meta: {requiresAuth: true
            ,requiresRole:'company_detail'},
        },
        {
          path: '/accounting-year',
          name: 'AccountingYear',
          component: AccountingYear,
          meta: {requiresAuth: true
            ,requiresRole:'company_detail'},
        },
        {
          path: '/add-discharge-place',
          name: 'DischargePlace',
          component: DischargePlace,
          meta: {requiresAuth: true
            ,requiresRole:'discharge_places'},
        },
        {
          path: '/users',
          name: 'Users',
          component: Users,
          meta: {requiresAuth: true
            ,requiresRole:'users'},
        },
        {
          path: '/price-buy-delivery',
          name: 'InsertPriceBuyDelivery',
          component: InsertPriceBuyDelivery,
          meta: {requiresAuth: true
            ,requiresRole:'delivery_load_price'},
        },
        {
          path: '/report-price-buy-delivery',
          name: 'ReportPriceBuyDelivery',
          component: ReportPriceBuyDelivery,
          meta: {requiresAuth: true
            ,requiresRole:'delivery_load_report'},
        },
        {
          path: '/insert-pre-payment',
          name: 'InsertPrePayment',
          component: InsertPrePayment,
          meta: {requiresAuth: true
            ,requiresRole:'assist_pay'},
        },
        {
          path: '/report-pre-payment',
          name: 'ReportPrePayment',
          component: ReportPrePayment,
          meta: {requiresAuth: true
            ,requiresRole:'assist_report'},
        },
        {
          path: '/insert-delivery-document',
          name: 'InsertDeliveryDocuments',
          component: InsertDeliveryDocuments,
          meta: {requiresAuth: true
            ,requiresRole:'transport_insert'},
        },
        {
          path: '/report-delivery-document',
          name: 'ReportDeliveryDocuments',
          component: ReportDeliveryDocuments,
          meta: {requiresAuth: true
            ,requiresRole:'transport_report'},
        },
        {
          path: '/edit-delivery-document/:doc_id',
          name: 'EditDeliveryDocuments',
          component: InsertDeliveryDocuments,
          meta: {requiresAuth: true
            ,requiresRole:'transport_edit'},
        },
        //reports
        {
          path: '/report-driver-detail',
          name: 'ReportDriverDetail',
          component: ReportDriverDetail,
          meta: {requiresAuth: true
            ,requiresRole:'drivers_report'},
        },
        {
          path: '/report-delivery-load-detail',
          name: 'ReportDriverDetail',
          component: ReportDeliveryLoadDetail,
          meta: {requiresAuth: true
            ,requiresRole:'delivery_low_report'},
        },
        {
          path: '/list-delivery-load',
          name: 'ListDeliveryLoad',
          component: ListDeliveryLoad,
          meta: {requiresAuth: true
            ,requiresRole:'transfer_load_list'},
        },
        {
          path: '/report-all-list-delivery-load',
          name: 'ReportAllListDeliveryLoad',
          component: ReportAllListDeliveryLoad,
          meta: {requiresAuth: true
            ,requiresRole:'transport_total_report'},
        }
        ]
    },

    {
      path: '/pages/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '/pages/login',
          name: 'Login',
          component: Login
        },
        {
          path: '/pages/print_preview',
          name: 'PrintPreview',
          component: PrintPreview,
          meta: {requiresAuth: false},
        }
      ]
    }

  ]
}


function validate_user(next, to) {
  let self = this;
  const formData = new FormData()
  let url;
  url = "/api/validate-token";

  formData.append('token', localStorage.getItem('token'))

  axios.post(url, formData, {}).then((res) => {
    // console.log("validate token is " + res.data);
    // localStorage.setItem("adminName", res.data.admin_name);
    // localStorage.setItem("adminImage" , res.data.admin_image);

    if (res.data != 0) {
      console.log("validate is true");
      // localStorage.setItem("permissions2",res.data.permissions);

      let meta_role = to.meta.requiresRole;
      // console.log("user name is "+ this.user_permissions.includes("edit_settings"));
      if (meta_role == null) {
        console.log("requiresRole is null");
        next();

      } else {
        console.log("requiresRole is " + meta_role);
        console.log("permissions",localStorage.getItem("permissions"))
        let permissions = JSON.parse(localStorage.getItem("permissions"));
        if (permissions.includes(meta_role)) {
          console.log("user has permissions ");
          next();

        } else {
          alert('شما دسترسی مجاز ندارید')
          // next({
          //   path: '/dashboard/404',
          //   params: {nextUrl: to.fullPath}
          // });
        }

      }

    } else {
      console.log("validate is false");

      next({
        path: '/pages/login',
      })
    }
    // return res.data;
  })

      // axios.post(  '/admin/category', {
      //     name: self.name,
      //     description: self.description,
      //     image: self.image,
      //     cat: 0,
      // }).then(function (response) {
      //     self.name = '';
      //     self.description = '';
      //     // localStorage.setItem("api_token", response.data.access_token);
      //     // self.$router.push({ path: 'notes' });
      // })
      .catch(function (error) {
        // self.message = 'Incorrect E-mail or password';
        // self.showMessage = true;
        console.log(error);
      });

}
